import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import {
  HttpClientModule,
  HttpClientJsonpModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment, LibraryConfig } from "../environments/environment";

import { AppRoutingModule } from "./app-routing.module";
import { RouterModule } from "@angular/router";
import { HomeComponent } from "./components/forms/home/home.component";

/* components \ directives */
import { MenuBarComponent } from "./components/directives/menu-bar/menu-bar.component";
import { InstallComponent } from "./components/directives/install/install.component";
/* services \ global */
import { MenuBarService } from "./components/directives/menu-bar/menu-bar.service";
import { GlobalService } from "./services/global/global.service";
import { SettingsProvider } from "./services/global/settings-provider.service";
import { UpdateApplication } from "./services/global/update-application.service";
import { FormSuccessService } from "./services/forms/app-form-success-service";
import { ErrorMessageService } from "./services/forms/app-error-message-service";
import { LoadingService } from "./services/loading.service";
import { HttpRequestInterceptor } from "./interceptors/http-request-interceptor";
/* Kendo */
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
/* swal-library */
import { FeedbackLibModule } from "feedback-lib";
/* authorisation */
import { AuthenticationModule } from "./authentication/authentication.module";
import { OeamHierarchyComponent } from "./components/oeam-hierarchy/oeam-hierarchy.component";
import { AssetsFetchService } from "./services/app-data-fetch.service";
import { ConfirmationDialogModule } from './components/directives/confirmation-dialog/confirmation-dialog.module';

@NgModule({
  declarations: [
    AppComponent,
    InstallComponent,
    HomeComponent,
    MenuBarComponent,
    OeamHierarchyComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,
    DialogsModule, // Kendo modules
    DropDownsModule,
    ButtonsModule,
    AppRoutingModule,
    RouterModule,
    AuthenticationModule,
    FeedbackLibModule,
    LayoutModule,
    TreeViewModule,
    ConfirmationDialogModule,
    ServiceWorkerModule.register("./ngsw-worker.js", {
      enabled: environment.production,
    }),
  ],
  providers: [
    MenuBarService,
    UpdateApplication,
    SettingsProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: initialiseSettings,
      deps: [SettingsProvider],
      multi: true,
    },
    GlobalService,
    FormSuccessService,
    ErrorMessageService,
    AssetsFetchService,
    LoadingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function initialiseSettings(settingsProvider: SettingsProvider) {
  return () => settingsProvider.loadConfig();
}
